import { extendTheme } from "@chakra-ui/react";

export const CustomThemeConfig = {
    initialColorMode: 'light',
    useSystemColorMode: false,
    colors: {
        primary: {
            50: "rgb(5, 68, 53)",
            100: "rgb(5, 68, 63)",
            200: "rgb(5, 68, 73)",//d95123
            300: "rgb(5, 68, 83)",
            400: "rgb(5, 68, 93)",//ee6b2a
            500: "rgb(5, 68, 103)",//ef5a28
            600: "rgb(5, 68, 113)",
            700: "rgb(5, 68, 123)",
            800: "rgb(5, 68, 133)",
            900: "rgb(5, 68, 143)",
        },
        textColor: {
            navlink: '#666e82',
            selectedNavLink: '#be1e2d',
            headingColor: '#2e3d62',
            supportingText: '#666e82',
            headingBluish: "#2e3d62"
        },
    }
};

const theme = extendTheme(CustomThemeConfig);

export default theme;